import { get } from 'lodash'

export default {
  state: {
    page: {

    },
    crons: {},
    isFetchingCrons: false,
    cronApiLoadingTargets: {},
    cronLoading: null
  },
  mutations: {
    ADD_CRON(state, cron) {
      const { id } = cron

      if (id) {
        const newState = { ...state.crons }
        newState[ id ] = cron
        state.crons = newState
      }
    },
    REMOVE_CRON(state, id) {
      if (state.crons[ id ]) {
        const newState = { ...state.crons }
        delete newState[ id ]
        state.crons = newState
      }
    },
    PAUSE_CRON(state, id) {
      if (id in state.crons) {
        state.crons[ id ].state = 'PAUSED'
      }
    },
    RESUME_CRON(state, id) {
      if (id in state.crons) {
        state.crons[ id ].state = 'ENABLED'
      }
    },
    RUN_CRON(state, id) {
      // Mimic the lastAttemptTime
      const date = new Date()
      const seconds = date.getTime() / 1000;

      state.crons[ id ].lastAttemptTime = {
        nanos: 0,
        seconds,
      }
    },
    START_CRON_LOADING(state, id) {
      const newState = { ...state.cronApiLoadingTargets }
      newState[ id ] = true
      state.cronApiLoadingTargets = newState
    },
    STOP_CRON_LOADING(state, id) {
      const newState = { ...state.cronApiLoadingTargets }
      newState[ id ] = false
      state.cronApiLoadingTargets = newState
    },
    SET_IS_FETCHING_CRONS(state, val) {
      state.isFetchingCrons = !!val
    }
  },
  getters: {
    mapper: state => id => state.crons[id],
    getIsFetchingCrons: state => state.isFetchingCrons,
    isCronTargetLoading: state => id => {
      return state.cronApiLoadingTargets[ id ] === true
    },
    allCrons: state => Object.values(state.crons),
    getCron: (state) => (id) => state.crons[ id ] || {}
  },
  actions: {
    async createCron({ commit, dispatch }, cron) {
      await this.$api.post(`/api/cron/`, cron)
        .then(res => commit('ADD_CRON', res.data))
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
    },
    async updateCron({ commit, dispatch }, cron) {
      const { id } = cron
      await this.$api.patch(`/api/cron/${id}`, cron)
        .then(res => commit('ADD_CRON', res.data))
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
    },
    resumeCron({ commit, dispatch }, id) {
      commit('START_CRON_LOADING', id)

      this.$api.post(`/api/cron/${id}/resume`)
        .then(res => { commit('RESUME_CRON', id) })
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
        .finally(() => { commit('STOP_CRON_LOADING', id) })
    },
    pauseCron({ commit, dispatch }, id) {
      commit('START_CRON_LOADING', id)

      this.$api.post(`/api/cron/${id}/pause`)
        .then(res => { commit('PAUSE_CRON', id) })
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
        .finally(() => { commit('STOP_CRON_LOADING', id) })
    },
    runCron({ commit, dispatch }, id) {
      commit('START_CRON_LOADING', id)

      this.$api.post(`/api/cron/${id}/run`)
        .then(res => { commit('RUN_CRON', id) })
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
        .finally(() => { commit('STOP_CRON_LOADING', id) })
    },
    async deleteCron({ commit, dispatch }, id) {
      await this.$api.delete(`/api/cron/${id}`)
        .then(() => { commit('REMOVE_CRON', id) })
        .catch(res => {
          const { data } = res.response

          dispatch('snackBar', {
            text: `[${data.code}] ${data.message}`,
            color: 'error'
          })
        })
    },
    fetchCrons({ commit }) {
      commit('SET_IS_FETCHING_CRONS', true)

      const onSuccess = res => {
        const { data } = res
        data.forEach(cron => commit('ADD_CRON', cron))
      }

      this.$api.get('/api/cron')
        .then(onSuccess)
        .catch(e => console.log(e))
        .finally(() => { commit('SET_IS_FETCHING_CRONS', false) })
    }
  }
}
